module.exports = __webpack_public_path__ + "c4b31a8219c8e2d30c10ca9fe02351f1.png";